import { render } from "./GoBackLink.vue?vue&type=template&id=08690c22&lang=html"
import script from "./GoBackLink.vue?vue&type=script&lang=js"
export * from "./GoBackLink.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__